import React, { useEffect, useRef } from 'react';

import wed from '../assests/newurban/brand/dekin-logo.webp';
import int from '../assests/newurban/brand/haire-logo.webp';
import weding from '../assests/newurban/brand/lg-logo.webp';
import apliances from '../assests/newurban/brand/samsung-logo.webp';
import home from '../assests/newurban/brand/sony.webp';
import toshiba from '../assests/newurban/brand/toshiba-logoo.webp';
import orglogo from '../assests/train-gif-small.gif';

export default function Brand() {
  const marqueeRef = useRef(null);

  const services = [
    {
      image: orglogo,
      href: 'https://www.daikin.com/',
    },
    {
      image: wed,
      href: 'https://www.daikin.com/',
    },
    {
      image: int,
      href: 'https://www.haier.com/in/',
    },
    {
      image: weding,
      href: 'https://www.lgcorp.com/',
    },
    {
      image: apliances,
      href: 'https://www.samsung.com/in/',
    },
    {
      image: home,
      href: 'https://www.sony.co.in/homepage',
    },
    {
      image: toshiba,
      href: 'https://www.toshiba.com/tai/',
    },
    {
      image: wed,
      href: 'https://www.daikin.com/',
    },
  ];

  // Update servicesPerPage based on screen width
  useEffect(() => {
    const updateServicesPerPage = () => {
      if (window.innerWidth < 768) {
      }
    };

    // Initial check
    updateServicesPerPage();

    // Update on window resize
    window.addEventListener('resize', updateServicesPerPage);
    return () => window.removeEventListener('resize', updateServicesPerPage);
  }, []);

  // Stop the marquee on mouse hover
  const handleMouseEnter = () => {
    marqueeRef.current.style.animationPlayState = 'paused';
  };

  // Resume the marquee on mouse leave
  const handleMouseLeave = () => {
    marqueeRef.current.style.animationPlayState = 'running';
  };

  return (
    <>
      <div className="mx-auto w-full mb-10">
        {/* Title Section */}
        <div id="/services" className="mb-6 text-center mt-10">
          <h2 className="text-2xl md:text-3xl font-bold gradient-text mb-2">
            Brands We Repair and Install
          </h2>
          <p className="text-lg md:text-xl text-gray-500 font-light px-4 md:px-20">
            No matter where you got it, we can fix it. We repair most major
            brands and models.
          </p>
        </div>

        {/* Marquee Wrapper */}
        <div
          className="marquee-container overflow-hidden whitespace-nowrap  p-2"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <div className="marquee-content flex" ref={marqueeRef}>
            {services.map(service => (
              <div
                // key={service.href}
                className="flex-shrink-0 w-32 md:mx-10   rounded-lg overflow-hidden transform transition-transform duration-200 hover:scale-110 hover:shadow-2xl"
              >
                <img
                  src={service.image}
                  alt="brand logo"
                  className="object-center px-2 w-28 h-10 md:w-52 md:h-16"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* CSS for Marquee */}
      <style jsx>{`
        .marquee-container {
          width: 100%;
        }

        .marquee-content {
          animation: marquee 15s linear infinite;
        }

        @keyframes marquee {
          from {
            transform: translateX(100%);
          }
          to {
            transform: translateX(-100%);
          }
        }
      `}</style>
    </>
  );
}
